import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom"

import Home from './Home'
import Header from './Header'
import MigrationFromV3 from "./MigrationFromV3"

const App = () => {
  return (
    <>
      <Router>
        <Header />
        <Switch>
          <Route path="/migration-v3-to-v4">
            <MigrationFromV3 />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </Router>
    </>
  )
}

export default App